// @flow

import * as React from 'react';

type Props = {
  name: string,
  colour?: string,
};

class InlineSvg extends React.Component<Props> {
  render() {
    const { name, colour = 'cyan' } = this.props;

    let colourHex;

    switch (colour) {
      case 'cyan':
        colourHex = '#00aec7';
        break;
      case 'personas':
        colourHex = '#00acca';
        break;
      case 'deepCyan':
        colourHex = '#0f849e';
        break;
      case 'teal':
        colourHex = '#00b398';
        break;
      case 'blue':
        colourHex = '#004b87';
        break;
      case 'white':
        colourHex = '#ffffff';
        break;
      case 'black':
        colourHex = '#23211d';
        break;
      case 'currentColor':
        colourHex = 'currentColor';
        break;
      default:
        colourHex = '#00aec7'; // cyan
    }

    switch (name) {
      case 'triangle-right':
        return (
          <svg
            width="8px"
            height="14px"
            viewBox="0 0 8 14"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="Page-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <polygon
                id="Triangle"
                fill={colourHex}
                transform="translate(4.000000, 7.000000) rotate(90.000000) translate(-4.000000, -7.000000) "
                points="4 3 11 11 -3 11"
              />
            </g>
          </svg>
        );
      case 'success-story':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
            <path
              d="M 25 2 C 12.318 2 2 12.318 2 25 C 2 37.682 12.318 48 25 48 C 37.682 48 48 37.682 48 25 C 48 20.403 46.639641 16.119484 44.306641 12.521484 L 43.414062 13.414062 L 42.828125 14 L 42 14 L 40.242188 14 L 37.509766 16.732422 C 39.080766 19.103422 40 21.943 40 25 C 40 33.284 33.284 40 25 40 C 16.716 40 10 33.284 10 25 C 10 16.716 16.716 10 25 10 C 28.057 10 30.896578 10.919234 33.267578 12.490234 L 36 9.7578125 L 36 8 L 36 7.171875 L 36.585938 6.5859375 L 37.474609 5.6972656 C 33.878609 3.3632656 29.597 2 25 2 z M 43 3 L 38 8 L 38 10.585938 L 24.292969 24.292969 A 1.0001 1.0001 0 1 0 25.707031 25.707031 L 39.414062 12 L 42 12 L 47 7 L 43 7 L 43 3 z M 25 16 C 20.038 16 16 20.038 16 25 C 16 29.962 20.038 34 25 34 C 29.962 34 34 29.962 34 25 C 34 23.613 33.675281 22.304859 33.113281 21.130859 L 27.121094 27.121094 C 26.555094 27.688094 25.801 28 25 28 C 24.199 28 23.444906 27.688094 22.878906 27.121094 C 22.311906 26.555094 22 25.801 22 25 C 22 24.199 22.311906 23.444906 22.878906 22.878906 L 28.871094 16.886719 C 27.698094 16.321719 26.387 16 25 16 z"
              overflow="visible"
              fill={colourHex}
            />
          </svg>
        );
      case 'report':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
            version="1.1"
          >
            <path
              d="M 7 7 C 5.300781 7 4 8.300781 4 10 L 4 32 C 4 32.800781 4.3125 33.398438 4.8125 34 L 0.40625 39.8125 C 0.105469 40.113281 0 40.601563 0 41 L 0 42 C 0 42.800781 0.304688 43.59375 0.90625 44.09375 C 1.40625 44.695313 2.199219 45 3 45 L 47 45 C 47.800781 45 48.59375 44.695313 49.09375 44.09375 C 49.59375 43.492188 50 42.800781 50 42 L 50 41 C 50 40.601563 49.894531 40.113281 49.59375 39.8125 L 45.1875 34 C 45.6875 33.5 46 32.800781 46 32 L 46 10 C 46 8.300781 44.699219 7 43 7 Z M 7 9 L 43 9 C 43.601563 9 44 9.398438 44 10 L 44 32 C 44 32.601563 43.601563 33 43 33 L 7 33 C 6.398438 33 6 32.601563 6 32 L 6 10 C 6 9.398438 6.398438 9 7 9 Z M 24 11 L 24 31 L 26 31 L 26 11 Z M 9.71875 12 C 9.167969 12.078125 8.78125 12.589844 8.859375 13.140625 C 8.9375 13.691406 9.449219 14.078125 10 14 L 20 14 C 20.359375 14.003906 20.695313 13.816406 20.878906 13.503906 C 21.058594 13.191406 21.058594 12.808594 20.878906 12.496094 C 20.695313 12.183594 20.359375 11.996094 20 12 L 10 12 C 9.96875 12 9.9375 12 9.90625 12 C 9.875 12 9.84375 12 9.8125 12 C 9.78125 12 9.75 12 9.71875 12 Z M 29.71875 12 C 29.167969 12.078125 28.78125 12.589844 28.859375 13.140625 C 28.9375 13.691406 29.449219 14.078125 30 14 L 40 14 C 40.359375 14.003906 40.695313 13.816406 40.878906 13.503906 C 41.058594 13.191406 41.058594 12.808594 40.878906 12.496094 C 40.695313 12.183594 40.359375 11.996094 40 12 L 30 12 C 29.96875 12 29.9375 12 29.90625 12 C 29.875 12 29.84375 12 29.8125 12 C 29.78125 12 29.75 12 29.71875 12 Z M 9.71875 16 C 9.167969 16.078125 8.78125 16.589844 8.859375 17.140625 C 8.9375 17.691406 9.449219 18.078125 10 18 L 17 18 C 17.359375 18.003906 17.695313 17.816406 17.878906 17.503906 C 18.058594 17.191406 18.058594 16.808594 17.878906 16.496094 C 17.695313 16.183594 17.359375 15.996094 17 16 L 10 16 C 9.96875 16 9.9375 16 9.90625 16 C 9.875 16 9.84375 16 9.8125 16 C 9.78125 16 9.75 16 9.71875 16 Z M 29.71875 16 C 29.167969 16.078125 28.78125 16.589844 28.859375 17.140625 C 28.9375 17.691406 29.449219 18.078125 30 18 L 37 18 C 37.359375 18.003906 37.695313 17.816406 37.878906 17.503906 C 38.058594 17.191406 38.058594 16.808594 37.878906 16.496094 C 37.695313 16.183594 37.359375 15.996094 37 16 L 30 16 C 29.96875 16 29.9375 16 29.90625 16 C 29.875 16 29.84375 16 29.8125 16 C 29.78125 16 29.75 16 29.71875 16 Z M 9.71875 20 C 9.167969 20.078125 8.78125 20.589844 8.859375 21.140625 C 8.9375 21.691406 9.449219 22.078125 10 22 L 20 22 C 20.359375 22.003906 20.695313 21.816406 20.878906 21.503906 C 21.058594 21.191406 21.058594 20.808594 20.878906 20.496094 C 20.695313 20.183594 20.359375 19.996094 20 20 L 10 20 C 9.96875 20 9.9375 20 9.90625 20 C 9.875 20 9.84375 20 9.8125 20 C 9.78125 20 9.75 20 9.71875 20 Z M 29.71875 20 C 29.167969 20.078125 28.78125 20.589844 28.859375 21.140625 C 28.9375 21.691406 29.449219 22.078125 30 22 L 40 22 C 40.359375 22.003906 40.695313 21.816406 40.878906 21.503906 C 41.058594 21.191406 41.058594 20.808594 40.878906 20.496094 C 40.695313 20.183594 40.359375 19.996094 40 20 L 30 20 C 29.96875 20 29.9375 20 29.90625 20 C 29.875 20 29.84375 20 29.8125 20 C 29.78125 20 29.75 20 29.71875 20 Z M 9.71875 24 C 9.167969 24.078125 8.78125 24.589844 8.859375 25.140625 C 8.9375 25.691406 9.449219 26.078125 10 26 L 17 26 C 17.359375 26.003906 17.695313 25.816406 17.878906 25.503906 C 18.058594 25.191406 18.058594 24.808594 17.878906 24.496094 C 17.695313 24.183594 17.359375 23.996094 17 24 L 10 24 C 9.96875 24 9.9375 24 9.90625 24 C 9.875 24 9.84375 24 9.8125 24 C 9.78125 24 9.75 24 9.71875 24 Z M 29.71875 24 C 29.167969 24.078125 28.78125 24.589844 28.859375 25.140625 C 28.9375 25.691406 29.449219 26.078125 30 26 L 37 26 C 37.359375 26.003906 37.695313 25.816406 37.878906 25.503906 C 38.058594 25.191406 38.058594 24.808594 37.878906 24.496094 C 37.695313 24.183594 37.359375 23.996094 37 24 L 30 24 C 29.96875 24 29.9375 24 29.90625 24 C 29.875 24 29.84375 24 29.8125 24 C 29.78125 24 29.75 24 29.71875 24 Z M 9.71875 28 C 9.167969 28.078125 8.78125 28.589844 8.859375 29.140625 C 8.9375 29.691406 9.449219 30.078125 10 30 L 20 30 C 20.359375 30.003906 20.695313 29.816406 20.878906 29.503906 C 21.058594 29.191406 21.058594 28.808594 20.878906 28.496094 C 20.695313 28.183594 20.359375 27.996094 20 28 L 10 28 C 9.96875 28 9.9375 28 9.90625 28 C 9.875 28 9.84375 28 9.8125 28 C 9.78125 28 9.75 28 9.71875 28 Z M 29.71875 28 C 29.167969 28.078125 28.78125 28.589844 28.859375 29.140625 C 28.9375 29.691406 29.449219 30.078125 30 30 L 40 30 C 40.359375 30.003906 40.695313 29.816406 40.878906 29.503906 C 41.058594 29.191406 41.058594 28.808594 40.878906 28.496094 C 40.695313 28.183594 40.359375 27.996094 40 28 L 30 28 C 29.96875 28 29.9375 28 29.90625 28 C 29.875 28 29.84375 28 29.8125 28 C 29.78125 28 29.75 28 29.71875 28 Z M 19.5 38 L 30.5 38 C 30.800781 38 31.210938 38.199219 31.3125 38.5 L 33 41 L 17 41 L 18.6875 38.5 C 18.886719 38.199219 19.199219 38 19.5 38 Z "
              fill={colourHex}
            />
          </svg>
        );
      case 'press-release':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
            version="1.1"
          >
            <path
              d="M 1.9375 2.78125 C 1.386719 2.78125 0.9375 3.230469 0.9375 3.78125 L 0.9375 39.46875 C 0.9375 42.082031 1.699219 44.1875 3.25 45.71875 C 5.714844 48.15625 9.242188 48.21875 9.59375 48.21875 L 41.375 48.21875 C 41.429688 48.21875 41.773438 48.226563 42.25 48.15625 C 39.136719 47.761719 34.625 45.617188 34.625 39.46875 L 34.625 3.78125 C 34.625 3.230469 34.179688 2.78125 33.625 2.78125 Z M 36.625 9.5 L 36.625 39.46875 C 36.625 46.113281 43.039063 46.21875 43.3125 46.21875 C 43.851563 46.214844 48.3125 46.011719 49 40.90625 C 49.046875 40.472656 49.0625 40.019531 49.0625 39.53125 L 49.0625 14.4375 C 49.0625 14.433594 49.0625 14.410156 49.0625 14.40625 C 49.027344 12.957031 48.25 10.414063 45.65625 9.71875 C 44.84375 9.914063 44.167969 10.277344 43.65625 10.8125 C 42.332031 12.195313 42.375 14.324219 42.375 14.34375 L 42.375 38.625 C 42.375 39.179688 41.929688 39.625 41.375 39.625 C 40.820313 39.625 40.375 39.179688 40.375 38.625 L 40.375 14.375 C 40.371094 14.300781 40.273438 11.511719 42.125 9.5 Z M 7.21875 11 L 26.9375 11 C 27.492188 11 27.9375 11.449219 27.9375 12 C 27.9375 12.550781 27.492188 13 26.9375 13 L 7.21875 13 C 6.667969 13 6.21875 12.550781 6.21875 12 C 6.21875 11.449219 6.667969 11 7.21875 11 Z M 7.21875 15 L 26.9375 15 C 27.492188 15 27.9375 15.449219 27.9375 16 C 27.9375 16.550781 27.492188 17 26.9375 17 L 7.21875 17 C 6.667969 17 6.21875 16.550781 6.21875 16 C 6.21875 15.449219 6.667969 15 7.21875 15 Z M 7.6875 23 L 14.46875 23 C 15.019531 23 15.46875 23.449219 15.46875 24 C 15.46875 24.550781 15.019531 25 14.46875 25 L 7.6875 25 C 7.136719 25 6.6875 24.550781 6.6875 24 C 6.6875 23.449219 7.136719 23 7.6875 23 Z M 19.21875 23 L 26.9375 23 C 27.492188 23 27.9375 23.449219 27.9375 24 C 27.9375 24.550781 27.492188 25 26.9375 25 L 19.21875 25 C 18.667969 25 18.21875 24.550781 18.21875 24 C 18.21875 23.449219 18.667969 23 19.21875 23 Z M 7.6875 27 L 14.46875 27 C 15.019531 27 15.46875 27.445313 15.46875 28 C 15.46875 28.554688 15.019531 29 14.46875 29 L 7.6875 29 C 7.136719 29 6.6875 28.554688 6.6875 28 C 6.6875 27.445313 7.136719 27 7.6875 27 Z M 19.21875 27 L 26.9375 27 C 27.492188 27 27.9375 27.445313 27.9375 28 C 27.9375 28.554688 27.492188 29 26.9375 29 L 19.21875 29 C 18.667969 29 18.21875 28.554688 18.21875 28 C 18.21875 27.445313 18.667969 27 19.21875 27 Z M 19.21875 30.78125 L 26.9375 30.78125 C 27.492188 30.78125 27.9375 31.226563 27.9375 31.78125 C 27.9375 32.335938 27.492188 32.78125 26.9375 32.78125 L 19.21875 32.78125 C 18.667969 32.78125 18.21875 32.335938 18.21875 31.78125 C 18.21875 31.226563 18.667969 30.78125 19.21875 30.78125 Z M 7.6875 31 L 14.46875 31 C 15.019531 31 15.46875 31.445313 15.46875 32 C 15.46875 32.554688 15.019531 33 14.46875 33 L 7.6875 33 C 7.136719 33 6.6875 32.554688 6.6875 32 C 6.6875 31.445313 7.136719 31 7.6875 31 Z M 19.21875 34.78125 L 26.9375 34.78125 C 27.492188 34.78125 27.9375 35.226563 27.9375 35.78125 C 27.9375 36.335938 27.492188 36.78125 26.9375 36.78125 L 19.21875 36.78125 C 18.667969 36.78125 18.21875 36.335938 18.21875 35.78125 C 18.21875 35.226563 18.667969 34.78125 19.21875 34.78125 Z M 7.6875 35 L 14.46875 35 C 15.019531 35 15.46875 35.445313 15.46875 36 C 15.46875 36.554688 15.019531 37 14.46875 37 L 7.6875 37 C 7.136719 37 6.6875 36.554688 6.6875 36 C 6.6875 35.445313 7.136719 35 7.6875 35 Z M 19.21875 38.53125 L 26.9375 38.53125 C 27.492188 38.53125 27.9375 38.976563 27.9375 39.53125 C 27.9375 40.085938 27.492188 40.53125 26.9375 40.53125 L 19.21875 40.53125 C 18.667969 40.53125 18.21875 40.085938 18.21875 39.53125 C 18.21875 38.976563 18.667969 38.53125 19.21875 38.53125 Z M 7.6875 39 L 14.46875 39 C 15.019531 39 15.46875 39.445313 15.46875 40 C 15.46875 40.554688 15.019531 41 14.46875 41 L 7.6875 41 C 7.136719 41 6.6875 40.554688 6.6875 40 C 6.6875 39.445313 7.136719 39 7.6875 39 Z "
              fill={colourHex}
            />
          </svg>
        );
      case 'video':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
            <path
              d="M25,2C12.318,2,2,12.317,2,25s10.318,23,23,23s23-10.317,23-23S37.682,2,25,2z M18.042,36.034l-0.083-21.996L37,24.964 L18.042,36.034z"
              fill={colourHex}
            />
          </svg>
        );
      case 'email':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
            <path
              d="M 0 7 L 0 9.78125 C 3.011719 12.402344 20.289063 27.464844 21.65625 28.65625 C 23.0625 29.882813 24.464844 30 25 30 C 25.535156 30 26.9375 29.882813 28.34375 28.65625 C 29.761719 27.421875 48.046875 11.480469 50 9.78125 L 50 7 Z M 0 12.4375 L 0 37.53125 L 15.125 25.59375 C 10.222656 21.328125 3.230469 15.25 0 12.4375 Z M 50 12.4375 C 46.949219 15.09375 39.847656 21.265625 34.875 25.59375 L 50 37.5 Z M 16.65625 26.9375 L 0 40.0625 L 0 43 L 50 43 L 50 40.03125 L 33.34375 26.9375 C 31.40625 28.625 30.011719 29.847656 29.65625 30.15625 C 27.738281 31.824219 25.757813 32 25 32 C 24.242188 32 22.261719 31.828125 20.34375 30.15625 C 19.992188 29.851563 18.597656 28.628906 16.65625 26.9375 Z "
              fill={colourHex}
            />
          </svg>
        );
      case 'phone':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
            <path
              d="M 39.03125 47 C 39.015625 47 39 47 38.984375 47 C 31.46875 46.753906 22.664063 39.46875 16.597656 33.398438 C 10.523438 27.328125 3.238281 18.519531 3.003906 11.039063 C 2.917969 8.414063 9.359375 3.746094 9.425781 3.699219 C 11.097656 2.535156 12.953125 2.949219 13.714844 4.003906 C 14.230469 4.71875 19.113281 12.117188 19.644531 12.957031 C 20.195313 13.828125 20.113281 15.125 19.425781 16.425781 C 19.046875 17.148438 17.789063 19.359375 17.199219 20.390625 C 17.835938 21.296875 19.519531 23.519531 22.996094 26.996094 C 26.476563 30.472656 28.695313 32.160156 29.605469 32.796875 C 30.636719 32.207031 32.847656 30.949219 33.570313 30.570313 C 34.851563 29.890625 36.140625 29.804688 37.019531 30.34375 C 37.917969 30.894531 45.296875 35.800781 45.976563 36.273438 C 46.546875 36.675781 46.914063 37.363281 46.988281 38.164063 C 47.058594 38.972656 46.808594 39.828125 46.289063 40.574219 C 46.246094 40.636719 41.632813 47 39.03125 47 Z "
              fill={colourHex}
            />
          </svg>
        );
      case 'location':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
              fill={colourHex}
            />
          </svg>
        );
      case 'arrow-left':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
            className="arrow-left"
          >
            <path
              d="M 19.9375 12.96875 C 19.414063 12.988281 18.921875 13.214844 18.5625 13.59375 L 8.6875 23.59375 L 7.3125 25 L 8.6875 26.40625 L 18.5625 36.40625 C 19.339844 37.199219 20.613281 37.214844 21.40625 36.4375 C 22.199219 35.660156 22.214844 34.386719 21.4375 33.59375 L 14.90625 27 L 40 27 C 40.722656 27.011719 41.390625 26.632813 41.753906 26.007813 C 42.121094 25.386719 42.121094 24.613281 41.753906 23.992188 C 41.390625 23.367188 40.722656 22.988281 40 23 L 14.90625 23 L 21.4375 16.40625 C 22.039063 15.824219 22.21875 14.933594 21.882813 14.164063 C 21.546875 13.398438 20.773438 12.921875 19.9375 12.96875 Z "
              fill={colourHex}
            />
          </svg>
        );
      case 'arrow-right':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -8.75 35 35"
            className="arrow-right"
          >
            <path
              d="M23.4207 8.53084C23.8113 8.14031 23.8113 7.50715 23.4207 7.11662L17.0568 0.752663C16.6662 0.362138 16.0331 0.362138 15.6426 0.752663C15.252 1.14319 15.252 1.77635 15.6426 2.16688L21.2994 7.82373L15.6426 13.4806C15.252 13.8711 15.252 14.5043 15.6426 14.8948C16.0331 15.2853 16.6662 15.2853 17.0568 14.8948L23.4207 8.53084ZM0.996582 8.82373H22.7136V6.82373H0.996582V8.82373Z"
              fill={colourHex}
            />
          </svg>
        );
      case 'actionable':
        return (
          <svg
            width="50"
            height="71"
            viewBox="0 0 50 71"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 60.6667L19.3496 68L37 46"
              stroke={colourHex}
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M38.5 15.5C38.5 23.2787 32.4099 29.5 25 29.5C17.5901 29.5 11.5 23.2787 11.5 15.5C11.5 7.72127 17.5901 1.5 25 1.5C32.4099 1.5 38.5 7.72127 38.5 15.5Z"
              stroke={colourHex}
              strokeWidth="3"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M46.2194 48.2594C41.156 42.1807 33.5298 38.3118 25 38.3118C16.4702 38.3118 8.84399 42.1807 3.78058 48.2594H0C5.54242 40.4259 14.674 35.3118 25 35.3118C35.326 35.3118 44.4575 40.4259 50 48.2594H46.2194Z"
              fill={colourHex}
            />
          </svg>
        );
      case 'chevron':
        return (
          <svg
            width="16"
            height="9"
            viewBox="0 0 16 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 1L8 8L1 0.999999"
              stroke={colourHex}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case 'download':
        return (
          <svg
            width="19"
            height="20"
            viewBox="0 0 19 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.625 12.375V15.5417C16.625 15.9616 16.4582 16.3643 16.1613 16.6613C15.8643 16.9582 15.4616 17.125 15.0417 17.125H3.95833C3.53841 17.125 3.13568 16.9582 2.83875 16.6613C2.54181 16.3643 2.375 15.9616 2.375 15.5417V12.375"
              stroke={colourHex}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.54175 8.41663L9.50008 12.375L13.4584 8.41663"
              stroke={colourHex}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.5 12.375V2.875"
              stroke={colourHex}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      default:
        return <strong>Error: no case in InlineSVG for {name}</strong>;
    }
  }
}

export default InlineSvg;
